import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '@/services/auth'
import LoginView from '../views/LoginView.vue'
import DashboardView from '../views/DashboardView.vue'
import ClientsView from '../views/ClientsView.vue'
import ClientDetailView from '../views/ClientDetailView.vue'
import PlansView from '../views/PlansView.vue'

const routes = [
  { path: '/login', name: 'login', component: LoginView,
    meta: { title: 'Login' } },
  { path: '/', name: 'dashboard', component: DashboardView,
    meta: { title: 'Visão geral', auth: true } },
  { path: '/clients', name: 'clients', component: ClientsView,
    meta: { title: 'Clientes', auth: true } },
  { path: '/clients/:id', name: 'client-detail', component: ClientDetailView,
    meta: { title: 'Detalhes do Cliente', auth: true } },
  { path: '/plans', name: 'plans', component: PlansView,
    meta: { title: 'Planos', auth: true } },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  document.title = (to.meta?.title ? to.meta.title + ' - ' : '') + 'LC3 Market Admin';

  if (!to.meta?.auth) {
    next();
    return;
  }

  const auth = useAuth();
  if (auth.token && await auth.checkAuth()) {
    next();
  } else {
    next({ name: 'login' });
  }
});

export default router
